<template>
  <main class="story-shell">
    <iframe class="story-frame" :src="storySource" title="라피아 공주 이야기" allow="fullscreen"></iframe>
  </main>
</template>

<script>
export default {
  computed: {
    storySource() {
      const params = new URLSearchParams()
      Object.keys(this.$route.query).forEach((key) => {
        const value = this.$route.query[key]
        if (Array.isArray(value)) value.forEach((item) => params.append(key, item))
        else if (value != null) params.set(key, value)
      })
      params.set("embedded", "1")
      return `/mian_00_story.html?${params.toString()}`
    },
  },
}
</script>

<style scoped>
.story-shell {
  width: 100%;
  height: calc(100vh - 132px);
  height: calc(100dvh - 132px);
  margin-bottom: 72px !important;
  overflow: hidden;
  background: #fff;
}

.story-frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}
</style>
